import {
    HOTEL_PHOTO_URL,
    HOTEL_PHOTO_SPRITE_URL,
    AIR_COMPANY_LOGO_URL,
    RESORT_IMAGE_HANDLER_URL,
    PLACEHOLDER_IMAGE_HANDLER_URL
} from '../consts/urls';
import { HotelImageUrlParams, HotelImageSpriteUrlParams, ResortImageUrlParams } from '../models/urls';
import { addVersionId } from '../../utils/url';
import { TourStore as TourModel } from '../stores/tour';


export function getHotelPhotoUrl(params: HotelImageUrlParams): string {
    return `${HOTEL_PHOTO_URL}${params.hotelId}_${params.index}_${params.width}_${params.height}_1.jpg`;
}

export function getResortImage(params: ResortImageUrlParams) {
    return `${RESORT_IMAGE_HANDLER_URL}?resort=${params.resortId}&width=${params.width}&height=${params.height}`;
}

export function getPlaceHolderImage(width: number, height: number) {
    return `${PLACEHOLDER_IMAGE_HANDLER_URL}/${width}x${height}.jpg`;
}

export function getHotelPhotoSpriteUrl(params: HotelImageSpriteUrlParams): string {
    return `${HOTEL_PHOTO_SPRITE_URL}${params.hotelId}_${params.width}_${params.height}_1.jpg`;
}

export function getAirCompanyUrl(airCompanyId: string): string {
    return `${AIR_COMPANY_LOGO_URL}${airCompanyId}_2x.png`;
}

export function getBuyInOfficeFormUrl(tour: TourModel): string {
    return addVersionId(`/tour/${tour.sourceId}-${tour.offerId}-${tour.requestId}/buy/#inoffice`);
}
